import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [scoreResult, setScoreResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const clearResults = () => {
    setSearchResults([]);
    setSelectedCompany(null);
    setScoreResult(null);
    setError(null);
  };

  const clearScore = () => {
    setScoreResult(null);
    setError(null);
  };

  return (
    <AppContext.Provider value={{
      searchQuery,
      setSearchQuery,
      searchResults,
      setSearchResults,
      selectedCompany,
      setSelectedCompany,
      scoreResult,
      setScoreResult,
      isLoading,
      setIsLoading,
      error,
      setError,
      clearResults,
      clearScore
    }}>
      {children}
    </AppContext.Provider>
  );
};
